import { PageLoadError } from 'design-system/src/components/PageLoadError/PageLoadError';
import { LoadingSpinner } from 'design-system/src/components/LoadingSpinner/LoadingSpinner';
import { FormFillerApi, FormFillerProvider, CheckboxFeaturesMap } from './FormFillerProvider';
import {
  useFormFillerInitialData,
  useFormFillerSuccessScreen,
  useFormFillerCompletedDocumentUrl,
  useFormFillerShowLogo,
} from './hooks';
import { PDFDisplayWithOverlay } from './PDFDisplayWithOverlay';
import { CompletedFormPage } from './CompletedFormPage';
import { FormTopBar } from '../forms/FormTopBar';
import { SuccessScreen } from './SuccessScreen';
import { FormRole } from '../../types/formFiller';

export function FormFillerContent({ token, sidebar }: { token: string; sidebar: React.ReactNode | null }) {
  const [shouldShowSuccessScreen] = useFormFillerSuccessScreen();
  const initialData = useFormFillerInitialData();
  const getCompletedDocumentUrl = useFormFillerCompletedDocumentUrl();
  const showLogo = useFormFillerShowLogo();

  if (initialData.status === 'loading') {
    return <LoadingSpinner />;
  }

  if (initialData.status === 'error') {
    return (
      <>
        <FormTopBar showLogo={showLogo} />
        <PageLoadError />
      </>
    );
  }
  if (shouldShowSuccessScreen) {
    const downloadUrl = getCompletedDocumentUrl(token, /* attachment */ true);
    return <SuccessScreen formName={initialData.displayTitle} downloadUrl={downloadUrl} />;
  }

  if (initialData.roleCompletedAt !== null) {
    return (
      <CompletedFormPage token={token} formName={initialData.displayTitle} completedAt={initialData.roleCompletedAt} />
    );
  }
  return <PDFDisplayWithOverlay initialData={initialData} sidebar={sidebar} />;
}
export function FormFiller({
  api,
  token,
  role,
  sidebar,
  formName,
  customTitle,
  allowSignatureUpload,
  checkboxFeatures,
  onSubmit,
  showLogo,
}: {
  api: FormFillerApi;
  token: string;
  role: FormRole;
  sidebar: React.ReactNode | null;
  formName: string;
  customTitle?: string;
  allowSignatureUpload: boolean;
  checkboxFeatures?: CheckboxFeaturesMap;
  onSubmit?: () => void;
  showLogo?: boolean;
}) {
  return (
    <FormFillerProvider
      api={api}
      token={token}
      role={role}
      formName={formName}
      customTitle={customTitle}
      allowSignatureUpload={allowSignatureUpload}
      checkboxFeatures={checkboxFeatures}
      onSubmit={onSubmit}
      showLogo={showLogo}
    >
      <FormFillerContent token={token} sidebar={sidebar} />
    </FormFillerProvider>
  );
}
